import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GDPR_SIGN_OPT_IN = createFcmDetails('gdpr_sign_opt_in', {
	owner: 'supporters pack',
	context: 'petition page',
	description: 'Indicates whether to display the GDPR opt-in checkboxes to guests.',
	import: false,
});
